import Vue from 'vue'
import App from '@/App'
import VueAxios from 'vue-axios'
import axios from 'axios'
import VueGtag from 'vue-gtag'
import store from '@/store/store'
import router from '@/router/router'
// import AxiosPlugin from 'vue-axios-cors'

Vue.use(VueAxios, axios)
Vue.use(VueGtag, {
  config: {
    id: 'G-QMR0TGM1ZM',
    params: {
      send_page_view: false
    }
  }
}, router);

(() => new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App),
  created () {
    // this.$store.dispatch('getProduct')
  }
}))()



// WEBPACK FOOTER //
// ./src/main.js